import { Component, Renderer2 } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'my-app',
  templateUrl: './dining-guide-region.component.html',
  styleUrls: ['./dining-guide-region.component.css']
})
export class DiningGuideRegionComponent {

  //regionsLevel1: any = null;
  //regionsLevel2: any = null;
  //parentRegionName: string;

  friendlyUrl: string;
  region: any = null;
  //selectedRegionIdLevel1: number = 0;
  //selectedRegionName: string;
  //selectedRegionFriendlyUrlLevel1: string;

  //selectedRegionIdLevel2: number = 0;
  //selectedRegionNameLevel2: string;
  //selectedRegionFriendlyUrlLevel2: string;

  //selectedRegionIdLevel3: number = 0;

  childrenRegions: any = null;
  //childrenRegionsChildren: any = null;
  //winWidth: number = 0;

  constructor(
    private _http: Http,
    private renderer: Renderer2,
    private router: Router,
    private route: ActivatedRoute) {

  }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.setRouteArgs(params);
    })

    //this.selectedRegionName = "Spain";
    //this.parentRegionName = "Europea";

    //this.getLevel1Regions();
    //this.winWidth = window.innerWidth;
    //console.log("DG-subregion works!");
  }

  setRouteArgs(params) {

    this.friendlyUrl = params.friendlyUrl;

    this.getRegion();
  }

  getRegion() {
    this._http.get("region/getbyfriendlyUrl/" + this.friendlyUrl).toPromise().then((data) => {
      this.region = data.json();
      this.getRegionsChildren(this.region.id);
    }).catch();
  }

  getRegionsChildren(id) {
    this.childrenRegions = null;
    this._http.get("region/getsubregionsbyparentid/" + id).toPromise().then((data) => {
      this.childrenRegions = data.json();
      //console.log("getRegionsChildren called; id//this.childrenRegions", id, this.childrenRegions);
    }).catch();
  }

}
